import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddTestQuestion from "./AddTestQuestion"; // New button component
import "./TestQuestions.css"; // Create this CSS file
import AddTestQuestionForm from "./AddTestQuestionForm";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRounded from "@mui/icons-material/DeleteRounded";

interface TestQuestionsProps {
    testQuestions: any[];
    onAddTestQuestion: (newQuestion: any) => void;
    onEditTestQuestion: (index: number, updatedQuestion: any) => void;
    onDeleteTestQuestion: (index: number) => void; // New prop for deletion
}

function TestQuestions({ testQuestions, onAddTestQuestion, onEditTestQuestion, onDeleteTestQuestion }: TestQuestionsProps) {
    const [editIndex, setEditIndex] = React.useState<number | null>(null);

    const handleEditClick = (index: number) => {
        setEditIndex(index);
    };

    const handleDeleteClick = (index: number) => {
        if (window.confirm("Are you sure you want to delete this test question?")) {
            onDeleteTestQuestion(index);
        }
    };

    return (
        <div className="allocateTableSize">
            <TableContainer component={Paper} className="p-3">
                <div className="d-flex justify-content-between">
                    <h2 className="m-2 header-downTables-dashboard">Test Questions</h2>
                    <AddTestQuestion onAddTestQuestion={onAddTestQuestion} />
                </div>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow className="table-head-dashboard">
                            <TableCell align="left">Question</TableCell>
                            <TableCell align="left">Type</TableCell>
                            <TableCell align="left">Options</TableCell>
                            <TableCell align="left">Edit</TableCell>
                            <TableCell align="left">Delete</TableCell> {/* New column */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {testQuestions.map((question, index) => (
                            <TableRow
                                hover={true}
                                key={index}
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">{question.question}</TableCell>
                                <TableCell align="left">{question.isSingleChoice ? "Single Choice" : "Multiple Choice"}</TableCell>
                                <TableCell align="left">{question.options.map((opt: any) => opt.optionText).join(", ")}</TableCell>
                                <TableCell align="left">
                                    <EditRoundedIcon
                                        style={{ color: "#8E8EA1", cursor: "pointer" }}
                                        onClick={() => handleEditClick(index)}
                                    />
                                </TableCell>
                                <TableCell align="left">
                                    <DeleteRounded
                                        style={{ color: "#FF0000", cursor: "pointer" }}
                                        onClick={() => handleDeleteClick(index)}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {editIndex !== null && (
                <AddTestQuestionForm
                    handleClose={() => setEditIndex(null)}
                    onAddTestQuestion={(updatedQuestion) => {
                        onEditTestQuestion(editIndex, updatedQuestion);
                        setEditIndex(null);
                    }}
                    initialData={testQuestions[editIndex]}
                />
            )}
        </div>
    );
}

export default TestQuestions;